import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss']
})
export class IconComponent implements OnInit {

    @Input() library: 'material' | 'prime' | 'fontawesome' | 'custom' = 'material';
    @Input() variant = '';
    @Input() placeholder = '';
    @HostBinding('class') @Input() type: 'info' | 'warning' | 'danger' | 'white' = 'info'
    @HostBinding('class.simple') @Input() simple = false;


    constructor() {
    }

    ngOnInit(): void {
    }

    computeCustomBackground() {
        switch (this.variant) {
            case 'strain':
                return 'url(\'assets/icons/custom_strain.svg\') no-repeat center center'
            case 'production':
                return 'url(\'assets/icons/custom_production.svg\') no-repeat center center'
            case 'ticket':
                return 'url(\'assets/icons/custom_production.svg\') no-repeat center center'
            case 'maintenance':
                return 'url(\'assets/icons/custom_production.svg\') no-repeat center center'
        }
    }
}
